export const AB_TEST_TYPES = {
    STANDARD: 'STANDARD',
    RESPONSIVE: 'RESPONSIVE',
    MOBILE: 'MOBILE',
} as const;

export const AB_TEST_VALUES = {
    CONTROL: 'CONTROL',
    VARIANT: 'VARIANT',
    INELIGIBLE: 'INELIGIBLE',
} as const;

export const AB_TEST_VARIANT_VALUES = {
    VARIANT1: 'VARIANT1',
    VARIANT2: 'VARIANT2',
} as const;

export const CDN_TEST_SLOTS = ['cdnTest1', 'cdnTest2', 'cdnTest3', 'cdnTest4'] as const;
export const SEO_TEST_SLOT = 'seoTest';
export const USER_TEST_SLOT = 'userTest';
export const ALL_TEST_SLOTS = [...CDN_TEST_SLOTS, SEO_TEST_SLOT, USER_TEST_SLOT] as const;

export const ABE_QUERY_PARAM = 'abe';
export const ABE_QUERY_PARAM_VALUES = {
    CONTROL: 'sc',
    DEFAULT: 'default',
    CDN_TEST_1: 'cdnTest1',
    CDN_TEST_2: 'cdnTest2',
    CDN_TEST_3: 'cdnTest3',
    CDN_TEST_4: 'cdnTest4',
} as const;

export const SEO_TEST = {
    FALSE: 'FALSE',
    TRUE: 'TRUE',
    SEO_ONLY: 'SEO_ONLY',
} as const;

export const CDN_TESTS_TAB = 'cdnTests';
export const AB_TESTS_V2_TAB = 'abTestsV2';
export const SEO_TESTS_TAB = 'seoTests';
export const USER_TESTS_TAB = 'userTests';
export const TAB_LABELS = {
    [AB_TESTS_V2_TAB]: 'A/B Tests',
    [CDN_TESTS_TAB]: 'CDN Tests (deprecated)',
    [SEO_TESTS_TAB]: 'SEO Tests',
    [USER_TESTS_TAB]: 'USER Tests',
} as const;
export const TAB_ORDER = [AB_TESTS_V2_TAB, CDN_TESTS_TAB, SEO_TESTS_TAB, USER_TESTS_TAB] as const;

export type AbTestTypeType = (typeof AB_TEST_TYPES)[keyof typeof AB_TEST_TYPES];
export type AbTestValueType = (typeof AB_TEST_VALUES)[keyof typeof AB_TEST_VALUES];
export type SeoTestType = (typeof SEO_TEST)[keyof typeof SEO_TEST];
